import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    label: {
      fontWeight: 500,
      color: '#2C2C2E',
      textAlign: 'left',
      wordBreak: 'break-word',
    },
    value: {
      fontSize: '13px',
      color: '#4D4F5C',
      fontWeight: 300,
      marginTop: 5,
      wordBreak: 'break-word',
    },
    button: {
      textTransform: 'capitalize',
      fontSize: 12,
    },
  };
});

export default useStyles;
